import clsx from "clsx";
import { useEffect } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useFormContext } from "react-hook-form";

import { Attachment } from "~/api/Api";
import { CRAWLER_FILE_TYPES } from "~/helpers/consts.ts";

import styles from "./Whitelist.module.scss";

export function PageImportForm({
  existingFile,
}: {
  existingFile?: Attachment | null;
}) {
  const { watch, setValue, register } = useFormContext();

  useEffect(() => {
    register("page_imports_attributes.input_file");
  }, [register]);

  const selectedFile = watch("page_imports_attributes.input_file");

  const handleFileChange = (incomingFile: File) => {
    setValue(
      "page_imports_attributes",
      { input_file: incomingFile },
      {
        shouldDirty: true,
      },
    );
  };

  return (
    <div className={clsx(styles.fileUploader)}>
      {existingFile?.filename && (
        <div className={styles.existingFileIndicator}>
          Currently uploaded file:{" "}
          {existingFile.url ? (
            <a
              href={existingFile.url}
              download={existingFile.filename}
              target="_blank"
              rel="noopener noreferrer"
            >
              {existingFile.filename}
            </a>
          ) : (
            existingFile.filename
          )}
        </div>
      )}

      <FileUploader
        name="file"
        types={CRAWLER_FILE_TYPES}
        handleChange={handleFileChange}
        uploadedLabel={
          selectedFile?.name ??
          (existingFile?.filename
            ? `${existingFile.filename} (from server)`
            : "Upload a CSV file")
        }
        fileOrFiles={selectedFile ?? undefined}
      />
    </div>
  );
}
